/**
 * SAB-977: the minimum native app version that can complete an OAuth round trip.
 *
 * ── WHY THIS IS A CONSTANT AND NOT A LITERAL ────────────────────────────────
 *
 * Four places gate on it: SocialAuthButtons itself, and the "or" divider on /login,
 * /signup and the desktop inline card. If they drift apart the divider orphans above an
 * empty space, which is how a "hidden" control still looks broken. One constant, four
 * consumers, no drift.
 *
 * ── WHY IT IS 1.3.0 ─────────────────────────────────────────────────────────
 *
 * OAuth on native returns through com.sabotagefantasy.app://auth-callback. Android never
 * registered that scheme -- AndroidManifest declared only MAIN/LAUNCHER -- so the browser
 * had nowhere to deliver the redirect, appUrlOpen never fired, and the sign-in hung in
 * loading forever. Every native Google and Apple attempt has dead-ended since 1.2.0, the
 * build that first showed the buttons.
 *
 * The manifest fix is native and cannot ship without a store release, so raising this
 * threshold above the shipped build is the only lever that reaches installed devices: the
 * app remote-loads prod, so this takes effect on the next web deploy. Google/Apple
 * disappear on 1.2.0 and reappear by themselves on the first build that declares 1.3.0.
 *
 * WHEN THE FIXED BUILD SHIPS, IT MUST DECLARE versionName 1.3.0 OR HIGHER. A build that
 * carries the manifest fix but still says 1.2.0 will keep hiding the buttons.
 *
 * ── WHAT THIS DOES NOT FIX ──────────────────────────────────────────────────
 *
 * A Google-only account still cannot get in on native by hiding the button. It replaces a
 * hang with a visible absence, which is better but not sufficient; the password form's
 * provider hint (authProviderHint) is the other half, and points those users at Forgot
 * password to set one.
 */
export const NATIVE_OAUTH_MIN_VERSION = '1.3.0';
